import { useState } from 'react';

/** Which confirmation is open, if any. */
export function useConfirm<T>() {
  const [target, setTarget] = useState<T | null>(null);
  return {
    target,
    ask: setTarget,
    close: () => {
      setTarget(null);
    },
  };
}
